import { ArrowStyleType } from '../../../../view-data/shared/line/general/arrow-style-type';
var StraightLineGeneralGoModelToDataConverter = /** @class */ (function () {
    function StraightLineGeneralGoModelToDataConverter(data) {
        this._stroke = data.stroke;
        this._strokeWidth = data.strokeWidth;
        this._lineType = data.lineType;
        this._arrow = {
            isArrow: data.isArrow ? data.isArrow : false,
            arrowStyle: data.arrowStyle ? data.arrowStyle : ArrowStyleType.CommonLeft
        };
    }
    Object.defineProperty(StraightLineGeneralGoModelToDataConverter.prototype, "stroke", {
        get: function () {
            return this._stroke;
        },
        set: function (v) {
            this._stroke = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StraightLineGeneralGoModelToDataConverter.prototype, "strokeWidth", {
        get: function () {
            return this._strokeWidth;
        },
        set: function (v) {
            this._strokeWidth = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StraightLineGeneralGoModelToDataConverter.prototype, "lineType", {
        get: function () {
            return this._lineType;
        },
        set: function (v) {
            this._lineType = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StraightLineGeneralGoModelToDataConverter.prototype, "arrow", {
        get: function () {
            return this._arrow;
        },
        set: function (v) {
            this._arrow = v;
        },
        enumerable: true,
        configurable: true
    });
    return StraightLineGeneralGoModelToDataConverter;
}());
export { StraightLineGeneralGoModelToDataConverter };
